// JavaScript Document
"use strict";
var Gcwannsee = {

    // All Functions
    init: function () {
        console.log('init');
        Gcwannsee.onScrollClass();
        Gcwannsee.onScrollClassGolfCourse();
        Gcwannsee.navigationClass();
        Gcwannsee.menuOverlayToggle();
        // Gcwannsee.perfectScrollInit();
        Gcwannsee.slickHomeSlider();
        Gcwannsee.slickGolfSlider();
        Gcwannsee.tournamentStickySection();
        Gcwannsee.navigateOnClick();
        Gcwannsee.youtubeThumbnail();
        Gcwannsee.vimeoThumbnail();
        Gcwannsee.newsAccordion();
        Gcwannsee.menuClassToggleMobile();

        $(window).resize(function() {
            Gcwannsee.loadResize();
        });

        Gcwannsee.loadResize();
    },

    loadResize: function() {
        Gcwannsee.menuClassToggleMobile();
        Gcwannsee.tournamentStickySection();
        //Reset the width value on window resize
        // Gcwannsee.windowWidth = document.body.clientWidth;
        //condition for the device width greater then and equal to 768
        // if (Gcwannsee.windowWidth >= 768) {}
    },

    // Login/Navigation Toggle in Mobile
    menuClassToggleMobile: function() {
        if(document.body.clientWidth < 576) {
            if ( $('.menu-overlay').hasClass('active') && $('body').hasClass('overflow-hidden') && $('#navToggle').hasClass('is-active')) {
                $('.menu-overlay').removeClass('active');
                $('body').removeClass('overflow-hidden');
                $('#navToggle').removeClass('is-active')
            }

            $("#loginToggle").click(function() {
                if($('.navigation-container').hasClass('d-none') && $('.login-main').hasClass('d-none')) {
                    $('.login-main').removeClass('d-none');
                    $('.navigation-container').removeClass('d-none');
                    $('.navigation-container').addClass('d-none');
                } else {
                    $('.navigation-container').addClass('d-none');
                }
            });

            $("#navToggle").click(function() {
                if($('.navigation-container').hasClass('d-none') && $('.login-main').hasClass('d-none')) {
                    $('.login-main').removeClass('d-none');
                    $('.navigation-container').removeClass('d-none');
                    $('.login-main').addClass('d-none');
                } else {
                    $('.login-main').addClass('d-none');
                }
            });

        } else {
            $('.login-main').removeClass('d-none');
            $('.navigation-container').removeClass('d-none');
            $("#loginToggle").click(function() {
                $('.login-main').removeClass('d-none');
                $('.navigation-container').removeClass('d-none');
            });
            $("#navToggle").click(function() {
                $('.login-main').removeClass('d-none');
                $('.navigation-container').removeClass('d-none');
            });
        }
    },

    //Scroll Add Class
    onScrollClass : function (){
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();

            if (scroll >= 100) {
                $(".main-header").addClass("header-scrolled");
                $(".blog-filter-tab").addClass("blog-filter-tab-stick");
            } else {
                $(".main-header").removeClass("header-scrolled");
                $(".blog-filter-tab").removeClass("blog-filter-tab-stick");
            }
        });
    },

    //Scroll Add Clas + Golf Course Page
    onScrollClassGolfCourse : function (){
        if($(".loch-filter-list")[0]) {
            $('.loch-filter-list').sticky({
                topSpacing: 73
            });
        }
    },

    //OnClick Redirects to Div
    navigateOnClick : function (){
        if($(".loch-main-row")[0]) {
            $('.collapse').on('shown.bs.collapse', function() {
                var lochRow = $(this).closest('.loch-main-row');
                var headerHeight = $('.main-header').height();
                var lochFilterHeight = $('.loch-filter-list').height();
                $('html,body').animate({
                    scrollTop: lochRow.offset().top - (headerHeight + lochFilterHeight)
                }, 500);
            })
        }
    },

    // Navigation Class Add & Remove
    navigationClass : function(){
        $('.menu > li > a').click( function() {
            if ( $(this).parents('li').hasClass('current-menu-parent') ) {
                $(this).parents('li').removeClass('current-menu-parent');
            } else {
                $('.menu > li.current-menu-parent').removeClass('current-menu-parent');
                $(this).parents('li').addClass('current-menu-parent');
            }
        });

        $('.menu a').click( function(event) {
            if ( $(this).attr('href') === '#' ) {
                event.preventDefault();
            }
        });
    },

    // Navigation Class Add & Remove
    menuOverlayToggle : function(){
        console.log('navi-init');
        $('#navToggle, #loginToggle').click( function() {
            console.log('navi');
            if ( $('.menu-overlay').hasClass('active') && $('#navToggle').hasClass('is-active')) {
            // if ( $('.menu-overlay').hasClass('active') && $('body').hasClass('overflow-hidden') && $('#navToggle').hasClass('is-active')) {
                $('.menu-overlay').removeClass('active');
                $('body').removeClass('overflow-hidden');
                $('#navToggle').removeClass('is-active')
            } else {
                $('.menu-overlay.active').removeClass('active');
                $('body.overflow-hidden').removeClass('overflow-hidden');
                $('#navToggle').removeClass('is-active')
                $('.menu-overlay').addClass('active');
                $('body').addClass('overflow-hidden');
                $('#navToggle').addClass('is-active')
            }
        });
    },

    // Perfect Scrollbar
    perfectScrollInit : function(){

        // Menu Overlay Scroll
        var menuOverlayContainer = document.querySelector('.scroll-content');
        var menuOverlayPS = new PerfectScrollbar(menuOverlayContainer);

        if($(".blog-filter-tab")[0]) {
            // Blog Filter Tab Scroll
            var blogFilterContainer = document.querySelector('.blog-filter-tab');
            var blogFilterPS = new PerfectScrollbar(blogFilterContainer);
        }
    },

    // Slick Slider Home Page
    slickHomeSlider : function(){
        $('.slick-init').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            useTransform: true,
            variableWidth: false,
            centerMode: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    },

    // Golf Detail Page Slider
    slickGolfSlider : function() {
        $('body').find("[class*=loch-image-slider]").each(function(i) {
            var sliderClass = $(this).attr('class');
            $("." + sliderClass).slick({
                dots: true,
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                adaptiveHeight: true
            });

            $("." + sliderClass).slickLightbox({
                closeOnBackdropClick : false,
                slick : function ($e) {

                $e.find('.slick-lightbox-slick-iframe').each(function () {
                    $(this)
                    .attr('data-src', $(this).attr('src'))
                    .attr('src', '')
                })

                function clearIframe (slick, index) {
                    var $iframe = $(slick.$slides.get(index)).find('.slick-lightbox-slick-iframe')
                    if ($iframe.length) {
                        setTimeout(function () {
                            $iframe.attr('src', '')
                        }, slick.options.speed)
                    }
                }

                function loadIframe (slick, index) {
                    var $iframe = $(slick.$slides.get(index)).find('.slick-lightbox-slick-iframe')
                    if ($iframe.length) $iframe.attr('src', $iframe.attr('data-src'))
                }

                return $e.find('.slick-lightbox-slick')
                    .on('init', function (event, slick) {
                        loadIframe(slick, slick.currentSlide)
                    })
                    .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                        clearIframe(slick, currentSlide)
                        loadIframe(slick, nextSlide)
                    })
                    .slick()
                }
            });
        });
    },

    // Accordion Event
    tournamentStickySection : function() {
        if($(".tournament-right-sticky")[0]) {
            var footerHeight = $('.site-footer').height();
            var tourLeftHeight = $('.tournament-left').height();
            var tourRightStickyHeight = $('.tournament-right-sticky').height();
            if(tourLeftHeight > tourRightStickyHeight) {
                $('.tournament-right-sticky').sticky({
                    topSpacing: 95,
                    bottomSpacing: footerHeight,
                });
            }
        }
    },

    // Fetch Youtube Thumbnail
    youtubeThumbnail : function() {
        $('body').find(".youtube-link").each(function(i){
            var youtubeSelector = $(this);
            var youtubeLink = youtubeSelector.attr('href');
            var youtubeId = youtubeLink.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();

            if (youtubeId.length == 11) {
                var youtubeThumbnail = $('<img src="//img.youtube.com/vi/'+youtubeId+'/maxresdefault.jpg">');
                $(this).empty();
                $(this).append(youtubeThumbnail);
            }
        });
    },

    // Fetch Vimeo Thumbnail
    vimeoThumbnail : function() {
        $('body').find(".vimeo-link").each(function(i){
            var vimeoSelector = $(this);
            var vimeoLink = vimeoSelector.attr('href');
            var vimeoLinkFetch;
            var vimeoId;

            if (vimeoLink.match(/https?:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/))
		    {
                vimeoLinkFetch = vimeoLink.match(/https?:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/).pop();
		        vimeoId = vimeoLinkFetch.split('/')[3];
		    }
		    else if (vimeoLink.match(/^vimeo.com\/channels\/[\d\w]+#[0-9]+/))
		    {
                vimeoLinkFetch = vimeoLink.match(/^vimeo.com\/channels\/[\d\w]+#[0-9]+/).pop();
		        vimeoId = vimeoLinkFetch.split('#')[1];
		    }
		    else if (vimeoLink.match(/vimeo.com\/groups\/[\d\w]+\/videos\/[0-9]+/))
		    {
                vimeoLinkFetch = vimeoLink.match(/vimeo.com\/groups\/[\d\w]+\/videos\/[0-9]+/).pop();
		        vimeoId = vimeoLinkFetch.split('/')[4];
		    }
		   	else if (vimeoLink.match(/player.vimeo.com\/video\/[0-9]+/))
		    {
                vimeoLinkFetch = vimeoLink.match(/player.vimeo.com\/video\/[0-9]+/).pop();
		        vimeoId = vimeoLinkFetch.split('/')[2];
            }

            $.getJSON('http://www.vimeo.com/api/v2/video/' + vimeoId + '.json?callback=?', {format: "json"}, function(data) {
                var viemoThumbnail = $('<img src='+ data[0].thumbnail_large +'>');
                vimeoSelector.empty();
                vimeoSelector.append(viemoThumbnail);
            });
        });
    },

    // News Accordion
    newsAccordion : function() {
        $('.news-grid-header').click(function(e) {
            e.preventDefault();

          var $this = $(this);

          if ($this.next().hasClass('show')) {
              $this.next().removeClass('show');
              $this.removeClass('active');
              $this.next().slideUp(350);
          } else {
              $this.parent().parent().find('.news-grid-content').removeClass('show');
              $this.parent().parent().find('.news-grid-header').removeClass('active');
              $this.parent().parent().find('.news-grid-content').slideUp(350);
              $this.next().toggleClass('show');
              $this.toggleClass('active');
              $this.next().slideToggle(350);
          }
      });
    }

};

(function () {
	window.onpageshow = function(event) {
		if (event.persisted) {
			window.location.reload();
		}
	};
})();

// when the page is ready, initialize everything
$(document).ready(function () {
    Gcwannsee.init();

    if ( $('[id^=wpforms-form').length > 0 ) {

        var firstname = getCookie('PC_FIRSTNAME');
        var lastname = getCookie('PC_NAME');
        var email = getCookie('PC_EMAIL');

        // $('.id_name input[type=text]').val(decodeURIComponent(firstname) + ' ' + decodeURIComponent(lastname));
        // $('.id_email input[type=email]').val(decodeURIComponent(email));

    }

    var getvars = getUrlVars();
    if( getvars.showaction == 1 ) {
        $('.ctasecret').removeClass('hide');
    }

    $('.nav-icon-lock-closed a').each(function(i) {
        var newText = $(this).text() + ' <i class="fas fa-lock small"></i>';
        $(this).html( newText );
    });
    $('.nav-icon-lock-open a').each(function(i) {
        var newText = $(this).text() + ' <i class="fas fa-lock-open small"></i>';
        $(this).html( newText );
    });

});

function setCookie(name,value,days)
{
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name)
{
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
